import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CacheBuster, Cacheable } from 'ts-cacheable';
import { API_ENDPOINTS } from '../../http/api-end-points';
import { CommonService } from '../common/common.service';
const cacheBuster$ = new Subject<void>();

@Injectable({
    providedIn: 'root',
})
export class AccessControlService {
    private subject = new Subject<any>();
    private detailsPopupSubject = new Subject<string>();
    private clearFilter = new Subject<boolean>();

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService
    ) { }
    public setFiltersAction(session: boolean) {
        this.clearFilter.next(session);
    }

    public getsetFiltersAction(): Observable<boolean> {
        return this.clearFilter.asObservable();
    }
    // Method to emit data
    sendMessage(message: any) {
        this.subject.next(message);
    }

    // Method to subscribe to the subject
    getMessage() {
        return this.subject.asObservable();
    }
    sendDetailsPopup(message: string) {
        this.detailsPopupSubject.next(message);
    }

    // Method to get the notification as an observable
    getDetailsPopup() {
        return this.detailsPopupSubject.asObservable();
    }
    //   @Cacheable({ cacheBusterObserver: cacheBuster$ })
    getRolesList(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl + API_ENDPOINTS.ACCESS_CONTROL.ROLES_LIST;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    //   @CacheBuster({
    //     cacheBusterNotifier: cacheBuster$,
    //   })
    deleteRole(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl + API_ENDPOINTS.ACCESS_CONTROL.DELETE_ROLE;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    //   @Cacheable()
    getPermissionsList(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl +
            API_ENDPOINTS.ACCESS_CONTROL.PERMISSION_LIST;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    createCustomRole(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl +
            API_ENDPOINTS.ACCESS_CONTROL.CREATE_CUSTOM_ROLE;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    updateCustomRole(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl +
            API_ENDPOINTS.ACCESS_CONTROL.UPDATE_CUSTOM_ROLE;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    fetchMemebersList(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl + API_ENDPOINTS.ACCESS_CONTROL.FETCH_MEMEBERS;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }

    viewAllRolePermissions(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl +
            API_ENDPOINTS.ACCESS_CONTROL.VIEW_ROLE_PERMISSIONS;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    //   @Cacheable()
    getProjectsList(body: any, type: string): Observable<any> {
        // debugger;
        let endPorint =
            type == 'owned'
                ? API_ENDPOINTS.PROJECTS.PROJECT_LIST_OWNED
                : API_ENDPOINTS.PROJECTS.PROJECT_LIST_SHARED;
        const url = environment.workspaceApiUrl + endPorint;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    //   @Cacheable()
    getUserPlanProjectsList(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl + API_ENDPOINTS.ACCESS_CONTROL.PROJECTS_LIST;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    inviteProject(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl +
            API_ENDPOINTS.ACCESS_CONTROL.PROJECTS_INVITE;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    revokeInvite(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl + API_ENDPOINTS.ACCESS_CONTROL.REVOKE_INVITE;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    deleteProject(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl + API_ENDPOINTS.ACCESS_CONTROL.DELETE_PROJECT;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }

    projectRoleAccess(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl +
            API_ENDPOINTS.ACCESS_CONTROL.PROJECT_ROLE_ACCESS;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
    workSpaceRoleAccess(body: any): Observable<any> {
        const url =
            environment.workspaceApiUrl +
            API_ENDPOINTS.ACCESS_CONTROL.WORKSPACE_ROLE_ACCESS;

        return this.commonService.performPostRequest(url, body, 'v2.5');
    }
}
